import React from 'react';
import Box from '@mui/material/Box';
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';

interface Props {
  readonly: boolean;
  dropzone: any; // Replace with your actual type
}

const FileUpload: React.FC<Props> = ({ dropzone, readonly }) => {
  const isReadOnly = readonly;

  return (
    <Box
      sx={{
        position: 'relative',
        '& ul': {
          listStyle: 'none',
          padding: 0,
        },
      }}
    >
      <Box
        {...(isReadOnly ? {} : dropzone.getRootProps({ className: 'dropzone' }))}
        sx={{
          cursor: isReadOnly ? 'default' : 'pointer',
          border: `dashed 2px ${dropzone.isDragAccept ? 'purple' : 'silver'}`,
          borderRadius: 2.5,
          p: 3,
          textAlign: 'center',
          color: 'text.secondary',
          backgroundColor: 'background.default',
        }}
      >
        {!isReadOnly && <input {...dropzone.getInputProps()} />}
        <ImageOutlinedIcon
          style={{
            fontSize: 40,
            color: dropzone.isDragAccept ? 'purple' : 'silver',
          }}
        />
        <p>{isReadOnly ? 'File upload disabled in viewing mode' : 'Drop an image file here, or click to select a file'}</p>
      </Box>
    </Box>
  );
};

export default FileUpload;
